<modal #modal [css-class]="'how-to-play-modal'">
  <div class="how-to-play">
    <button type="button" class="how-to-play__close" role="button" aria-label="Luk" aria-roledescription="Luk modal"
      (click)="closeModal()">
      <img src="../../../../../assets/icons/close-b.svg" />
    </button>

    <div class="how-to-play__content">
      <div class="header">
        <h2 class="how-to-play__heading"> Sådan fungerer det </h2>
        <p class="text-center">
          Her finder du alt information om, hvordan du <br> spiller med i hele Danmarks Millionlotteri.
        </p>
      </div>

      <section class="how-to-play__section">
        <div class="how-to-play__img">
          <img src="../../../../../assets/images/charts/kalender_02.svg" height="180" width="200" />
        </div>
        <div class="how-to-play__description">
          <h3 class="how-to-play__subheading">Trækninger</h3>
          <p>I Klasselotteriet er der 500.000 lodnumre fra 1 til 500.000, som alle deltager i den månedlige trækning.
            Vi trækker lod den 15. hver måned. De tusindvis af vindere offentliggøres den 15. Kl. 15.
          </p>
        </div>

        <div class="how-to-play__img">
          <img src="../../../../../assets/images/shop-purchase/Lodtyper_02ny.gif"
            class="how-to-play__animation displace" />
        </div>
        <div class="how-to-play__description">
          <h3 class="how-to-play__subheading">Lodtyper</h3>
          <p>Der findes 5 forskellige lodtyper, som du kan spille på i lotteriet: 1/8-lod, 1/4-lod, 1/2-lod, 1/1-lod og
            Megalod. Hvis du f.eks. spiller på et 1/1-lod, og dit nummer udtrækkes, beholder du hele
            gevinsten. Hvorimod du på et 1/8-lod deler gevinsten med 7 andre.</p>
        </div>

        <div class="how-to-play__img">
          <img src="../../../../../assets/images/charts/15_milliongevinster_hver_måned_02.svg" />
        </div>
        <div class="how-to-play__description">
          <h3 class="how-to-play__subheading">Milliongevinster</h3>
          <p>Når du spiller med i Klasselotteriet kan du give drømmene frit spil. Den 15. i hver måned trækker vi nemlig lod om hele 15 milliongevinster. Jo flere lodnumre du spiller med på, jo større er chancen for at du vinder.</p>
        </div>
        <div class="how-to-play__img">
          <img src="../../../../../assets/images/charts/antal_genvinst_tabel_02.svg" />
        </div>
        <div class="how-to-play__description">
          <h3 class="how-to-play__subheading">Gevinster</h3>
          <p>Hver måned trækkes der lod om mere end 24.000 kontante gevinster, herunder 15 milliongevinster. Størrelsen på din gevinst afhænger af din lodtype. Gevinsterne i tabellen er for 1/1 lodder. Spiller du på et 1/2 lod, vinder du halvdelen af en gevinst.</p>
        </div>
        <div class="how-to-play__img">
          <img src="../../../../../assets/images/shop-purchase/subscription.svg" />
        </div>
        <div class="how-to-play__description">
          <h3 class="how-to-play__subheading">Abonnement</h3>
          <p>Når du køber et lod på Klasselotteriets hjemmeside, oprettes det som et abonnement. Du kan vælge mellem abonnement på betalingskort eller Betalingsservice. Du kan efterfølgende opsige lodderne direkte på Min side. Ellers hjælper vores kundeservice dig også gerne med det.</p>
        </div>
        <div class="how-to-play__img">
          <img src="../../../../../assets/images/shop-purchase/wish-ticket.svg" />
        </div>
        <div class="how-to-play__description">
          <h3 class="how-to-play__subheading">Ønskelod</h3>
          <p>Du har mulighed for selv at vælge det lodnummer, som du spiller med på. Søg efter dit nummer i simulatoren
            og skift derefter mellem de forskellige lodtyper. Er dit ønskede nummer ikke ledigt, kan du kontakte
            kundeservice og blive skrevet op til det.</p>
        </div>
      </section>
    </div>

  </div>
</modal>
